<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Keqjqy/tc-custom/9783988267849.jpg?1704453544030" alt="This image is the cover for the book Uncle Wiggily's June Bug Friends, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncle Wiggily's June Bug Friends, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Another charming bedtime tale of that gentleman rabbit, Uncle Wiggily, as he tells how one good turn deserves another. A gentle lesson taught and a short adventure make this delightful story ideal for bedtime reading and pleasant dreams.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard Roger Garis
      </h2>
      
      <p class="authorDescription body article">Howard Roger Garis (April 25, 1873 – November 6, 1962) was an American author, best known for a series of books that featured the character of Uncle Wiggily Longears, an engaging elderly rabbit. Many of his books were illustrated by Lansing Campbell. Garis and his wife, Lilian Garis, were possibly the most prolific children's authors of the early 20th century.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?747f25db